import { Grid, Segment } from '@mairistem/composants';
import { formatMontant, Icon } from '@mairistem/finances-utils';
import { isEmpty } from 'lodash';
import React from 'react';
import type IMouvementProps from '../../../../interfaces/pieces/mouvements/liquidation/MouvementProps';
import getMouvementIcon from '../../../../utils/getMouvementIcon';
import renderMontant from '../../../../utils/mouvements/getMontantComptabilise';
import getTotalPj from '../../../../utils/mouvements/getTotalPj';
import MouvementPJCount from './MouvementPJCount';
import ZoomButton from './ZoomButton';
import './Mouvement.css';

const MouvementReduce = ({
	rowData,
	onClick,
	onDoubleClick,
	exercice,
}: IMouvementProps) => {
	const { mouvement } = rowData;

	const { mtHt, mtTtc, showPicto } = renderMontant({ mouvement, exercice });

	const totalPjCount = getTotalPj(mouvement);

	return (
		<Segment
			className="mouvement-container"
			onDoubleClick={onDoubleClick}
			data-testid={`mouvementRow${mouvement.identifiant}`}
		>
			<ZoomButton onClick={onClick} />
			<Grid columns={2} verticalAlign="middle">
				<Grid.Column width={8}>
					<Grid columns={3}>
						<Grid.Row>
							<Grid.Column
								width={2}
								className="mouvement-row-icon"
								verticalAlign="middle"
							>
								{getMouvementIcon(mouvement)} {mouvement.numero}
							</Grid.Column>
							<Grid.Column
								width={10}
								title={mouvement.objetPiece}
								className="mouvement-objet-piece mouvement-info-bold"
								verticalAlign="middle"
							>
								{isEmpty(mouvement.objetPiece.trim())
									? '-'
									: mouvement.objetPiece}
							</Grid.Column>
							<Grid.Column
								width={4}
								className="mouvement-info-bold"
								verticalAlign="middle"
							>
								{new Date(mouvement.date).toLocaleDateString('fr-FR', {
									day: '2-digit',
									month: '2-digit',
									year: 'numeric',
								})}
							</Grid.Column>
						</Grid.Row>
						<Grid.Row>
							<Grid.Column width={2} />
							<Grid.Column
								width={10}
								title={mouvement.informationLien}
								className="mouvement-info-grey mouvement-info-bold"
								verticalAlign="middle"
							>
								{isEmpty(mouvement.informationLien.trim())
									? '-'
									: mouvement.informationLien}
							</Grid.Column>
							<Grid.Column
								width={4}
								title={mouvement.informationImputation}
								className="mouvement-info-grey mouvement-info-bold"
								verticalAlign="middle"
							>
								{isEmpty(mouvement.informationImputation.trim())
									? '-'
									: mouvement.informationImputation}
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
				<Grid.Column width={7} floated="right">
					<Grid columns={3}>
						<Grid.Row verticalAlign="middle">
							<Grid.Column
								width={8}
								title={mouvement.informationTiers}
								className="mouvement-info-bold"
								verticalAlign="middle"
							>
								{isEmpty(mouvement.informationTiers.trim())
									? '-'
									: mouvement.informationTiers}
							</Grid.Column>
							<Grid.Column
								width={6}
								textAlign="right"
								className={
									!mtHt.comptabilise
										? 'mouvement-info-grey mouvement-info-bold'
										: 'mouvement-info-bold'
								}
							>
								{mtHt.value !== null && (
									<div className={mtHt.comptabilise ? 'row-picto' : ''}>
										{`${formatMontant(mtHt.value ?? 0, 2)} HT`}
										{mtHt.comptabilise && showPicto && (
											<Icon name="Banknote" iconSet="Lucide" color="black" />
										)}
									</div>
								)}
							</Grid.Column>
							{totalPjCount > 0 && (
								<Grid.Column width={2}>
									<MouvementPJCount totalPjCount={totalPjCount} />
								</Grid.Column>
							)}
						</Grid.Row>
						<Grid.Row verticalAlign="middle">
							<Grid.Column
								width={8}
								title="Viré sur FRXXXXXXXXXXXXXXXXXXXXXXXXX"
								className="mouvement-info-grey mouvement-info-bold"
								verticalAlign="middle"
							>
								{/* Voir avec manu pour RIB */}
								{/* Viré sur FRXXXXXXXXXXXXXXXXXXXXXXXXX */}
							</Grid.Column>
							<Grid.Column
								width={6}
								textAlign="right"
								className={
									!mtTtc.comptabilise
										? 'mouvement-info-grey mouvement-info-bold'
										: 'mouvement-info-bold'
								}
								verticalAlign="middle"
							>
								{mtTtc.value !== null && (
									<div className={mtTtc.comptabilise ? 'row-picto' : ''}>
										{`${formatMontant(mtTtc.value ?? 0, 2)} TTC`}
										{mtTtc.comptabilise && showPicto && (
											<Icon name="Banknote" iconSet="Lucide" color="black" />
										)}
									</div>
								)}
							</Grid.Column>
							<Grid.Column width={2} />
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid>
		</Segment>
	);
};

export default MouvementReduce;
